<section
  class="new-sec-event-container"
  #newSecEventElement
  [ngClass]="{ 'dashed-border': !isHovering, 'hover-border': isHovering }"
  (drop)="onDrop($event)"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
>
  <div class="content">
    <span
      class="video-camera-icon"
      inlineSVG="/assets/icons/video-camera.svg"
    ></span>
    <span class="drag-text">Drag media/graphic items here</span>
  </div>
</section>
